{
    "reorders__empty_title": "No recommendations for this customer",
    "reorders__empty_body": "Here you will find articles that the customer might need again soon.",

    "modal_title": "Select product variant",
    "search_variants_placeholder": "Search for products, etc.",

    "table_header__article_id": "Product ID",
    "table_header__article_name": "Product",
    "table_header__last_quantitiy": "Quantity ordered",
    "table_header__last_order_date": "Last order date",

    "submit_button": "Add Product"
}
